/* ============================================================================
   Landing « Liste VIP Black Friday » v2. Aucune dépendance, aucune librairie.
   Chargé en `defer` par la section hero, seulement sur ce modèle de page.

   window.bfvLanding.init() est idempotent : un élément déjà branché porte
   `data-bfv-bound` et n'est jamais rebranché. Il tourne au chargement et à chaque
   rechargement de section dans l'éditeur de thème (`shopify:section:load`).

   Inscription : si les identifiants Klaviyo sont renseignés (#bfv-config), l'envoi
   est intercepté et l'adresse part dans la liste Klaviyo dédiée. Sinon, ou si
   Klaviyo échoue / ne répond pas en 8 s, c'est le formulaire client Shopify qui part.
   ========================================================================= */
(function () {
  'use strict';

  if (window.bfvLanding) { window.bfvLanding.init(); return; }

  var STAR =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M12 2.2l2.95 5.98 6.6.96-4.78 4.66 1.13 6.57L12 17.27 6.1 20.37l1.13-6.57L2.45 9.14l6.6-.96z"/></svg>';

  /* doc Klaviyo « Create Client Subscription », vérifiée le 29/10/2026 */
  var KLAVIYO_URL = 'https://a.klaviyo.com/client/subscriptions?company_id=';
  var KLAVIYO_REVISION = '2026-10-15';
  var TIMEOUT_MS = 8000;

  /* le Lead ne part qu'une fois par page, même si deux formulaires sont « envoyés » */
  var published = false;

  /* relue à chaque appel : l'éditeur peut avoir remplacé la section entre-temps */
  function config() {
    var el = document.getElementById('bfv-config');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  }

  function bind(el) {
    if (el.hasAttribute('data-bfv-bound')) return false;
    el.setAttribute('data-bfv-bound', '');
    return true;
  }

  /* ?ref=whatsapp : la visite vient d'un lien partagé. Lettres, chiffres, - et _ seulement. */
  function ref() {
    var m = /[?&]ref=([a-z0-9_-]{1,30})(?:&|$)/i.exec(location.search);
    return m ? m[1].toLowerCase() : '';
  }

  /* source envoyée à Klaviyo et au Lead : l'adresse de la page, suffixée du ref (liste-vip-whatsapp) */
  function source(cfg) {
    var r = ref();
    return (cfg.source || '') + (r ? '-' + r : '');
  }

  /* résout true si Klaviyo a accepté l'inscription, false sinon (erreur, réseau, 8 s) */
  function subscribe(cfg, email) {
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer;
    var request = fetch(KLAVIYO_URL + encodeURIComponent(cfg.klaviyo.company), {
      method: 'POST',
      headers: {
        revision: KLAVIYO_REVISION,
        'content-type': 'application/vnd.api+json',
        accept: 'application/vnd.api+json'
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Liste VIP BF ' + source(cfg),
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { source: source(cfg) },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: cfg.klaviyo.list } } }
        }
      }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function (r) { return r.status >= 200 && r.status < 300; }, function () { return false; });
    var timeout = new Promise(function (resolve) {
      timer = setTimeout(function () { if (ctrl) ctrl.abort(); resolve(false); }, TIMEOUT_MS);
    });
    return Promise.race([request, timeout]).then(function (ok) { clearTimeout(timer); return ok; });
  }

  /* ───────── confirmation ───────── */

  /* bouton WhatsApp (celui de la clôture n'a que la config du hero) + événement pour
     la pub (pixel personnalisé → Lead Meta) */
  function armDone(done, cfg) {
    var share = done.querySelector('[data-bfv-share]');
    var label = share && share.querySelector('[data-bfv-share-label]');
    if (share && label && cfg.share && cfg.share.href && cfg.share.label) {
      share.href = cfg.share.href;
      label.textContent = cfg.share.label;
      share.hidden = false;
    }
    var analytics = window.Shopify && window.Shopify.analytics;
    if (!published && cfg.event && analytics && typeof analytics.publish === 'function') {
      published = true;
      try { analytics.publish(cfg.event, { source: source(cfg) }); } catch (e) { /* le pixel ne doit jamais casser la page */ }
    }
  }

  function showDone(wrap) {
    var cfg = config();
    var done = wrap.querySelector('[data-bfv-done]');
    var form = wrap.querySelector('form');
    if (!done) return;
    var title = done.querySelector('[data-bfv-done-title]');
    var text = done.querySelector('[data-bfv-done-text]');
    if (cfg.done && cfg.done.title && title) title.textContent = cfg.done.title;
    if (cfg.done && cfg.done.html && text) text.innerHTML = cfg.done.html;
    armDone(done, cfg);
    if (form) form.hidden = true;
    done.hidden = false;
    if (title) title.focus();
  }

  /* ───────── états par date ─────────
     'open' : inscriptions ouvertes ; 'closed' : de la clôture à l'ouverture publique
     (l'accès VIP est en cours) ; 'live' : Black Friday ouvert à tous. Calculé côté
     navigateur : le cache des pages Shopify ne permet pas de se fier au Liquid pour l'heure. */
  function pageState(now, st) {
    st = st || {};
    if (st.force === 'open' || st.force === 'closed' || st.force === 'live') return st.force;
    var close = Date.parse(st.close);
    var open = Date.parse(st.public);
    if (isNaN(close) || isNaN(open)) return 'open'; /* dates illisibles : on continue de collecter */
    if (now < close) return 'open';
    return now < open ? 'closed' : 'live';
  }

  function renderState(wrap, state, st) {
    var box = document.createElement('div');
    box.className = 'bfv-state';
    box.setAttribute('data-bfv-state', state);
    if (state === 'closed') {
      box.innerHTML = st.closedHtml || '';
      /* 🔴 aucun lien pendant l'accès VIP : la page est publique, un lien vers les ventes
         donnerait l'avant-première à tout le monde */
      box.querySelectorAll('a').forEach(function (a) { a.replaceWith(document.createTextNode(a.textContent)); });
    } else {
      var link = document.createElement('a');
      link.className = 'bfv-btn';
      link.href = st.liveUrl || '/';
      link.textContent = st.liveLabel || '';
      box.appendChild(link);
    }
    wrap.innerHTML = '';
    wrap.appendChild(box);
  }

  /* ───────── envoi ───────── */
  function unlock(wrap) {
    wrap.removeAttribute('data-bfv-busy');
    var form = wrap.querySelector('form');
    if (form) form.removeAttribute('aria-busy');
  }

  /* retour d'un envoi natif : on retire customer_posted de l'URL, pour qu'un rechargement
     ne republie pas l'événement (l'affichage est déjà rendu par le Liquid) */
  function cleanPostedUrl() {
    if (!/[?&]customer_posted=/.test(location.search) || !window.history.replaceState) return;
    var params = location.search.slice(1).split('&').filter(function (p) { return p.indexOf('customer_posted=') !== 0; });
    history.replaceState(history.state, '', location.pathname + (params.length ? '?' + params.join('&') : '') + location.hash);
  }

  function onSubmit(e, wrap, form) {
    var cfg = config();
    var k = cfg.klaviyo || {};
    if (!k.company || !k.list) return; /* pas d'identifiants : envoi natif Shopify */

    /* On garde la main. Le captcha de Shopify branche, au focus du champ, son propre
       écouteur `submit` sur ce formulaire (et un autre sur le document) : sans
       stopImmediatePropagation, il renverrait AUSSI le formulaire natif après Klaviyo. */
    e.preventDefault();
    e.stopImmediatePropagation();
    if (wrap.hasAttribute('data-bfv-busy')) return; /* double tap */

    var input = form.querySelector('input[type="email"]');
    var email = ((input && input.value) || '').trim().toLowerCase();
    if (!email) return;

    wrap.setAttribute('data-bfv-busy', '');
    form.setAttribute('aria-busy', 'true');
    subscribe(cfg, email).then(function (ok) {
      unlock(wrap);
      if (ok) showDone(wrap);
      /* filet : formulaire Shopify (avec son captcha s'il est branché). Le verrou est déjà
         levé : si le défi captcha est fermé, la visiteuse peut renvoyer. */
      else form.submit();
    });
  }

  function init() {
    /* étoiles : dessinées en JS pour ne pas répéter le SVG dans le Liquid */
    document.querySelectorAll('[data-bfv-stars]').forEach(function (el) {
      if (!bind(el)) return;
      el.innerHTML = STAR.repeat(5);
      el.setAttribute('role', 'img');
      el.setAttribute('aria-label', el.getAttribute('data-bfv-stars'));
    });

    var cfg = config();
    var state = pageState(Date.now(), cfg.states);
    document.querySelectorAll('[data-bfv-form]').forEach(function (wrap) {
      if (!bind(wrap)) return;
      if (state !== 'open') { renderState(wrap, state, cfg.states || {}); return; }
      var form = wrap.querySelector('form');
      if (!form) return;
      /* filet Shopify : l'étiquette dit aussi d'où vient la visite (ref-whatsapp) */
      var tags = form.querySelector('input[name="contact[tags]"]');
      if (tags && ref()) tags.value += ', ref-' + ref();
      /* phase de capture : à la cible, notre écouteur passe avant celui du captcha de
         Shopify même si celui-ci s'est branché le premier (champ touché pendant le chargement) */
      form.addEventListener('submit', function (e) { onSubmit(e, wrap, form); }, true);
    });

    /* retour d'un envoi natif réussi : la confirmation est déjà rendue par le Liquid */
    var posted = document.querySelectorAll('[data-bfv-posted]');
    posted.forEach(function (done) {
      if (bind(done)) armDone(done, config());
    });
    if (posted.length) cleanPostedUrl();
  }

  window.bfvLanding = { init: init, config: config, subscribe: subscribe, pageState: pageState };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  /* page restaurée par le bouton retour (bfcache) après un repli : on lève les verrous */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) document.querySelectorAll('[data-bfv-busy]').forEach(unlock);
  });
})();
